import type { CSSProperties } from "react";

import styles from "./SkeletonV2.module.css";

export type SkeletonV2Variant = "text" | "rounded";

/** Superficie sobre la que se pinta el skeleton. En `elev2` (p.ej. headers) el
 *  fill por defecto coincidiría con el fondo, así que sube un escalón de elevación. */
export type SkeletonV2Surface = "page" | "elev2";

interface Props {
  variant?: SkeletonV2Variant;
  surface?: SkeletonV2Surface;
  width?: NonNullable<CSSProperties["width"]>;
  height?: NonNullable<CSSProperties["height"]>;
  "data-testid"?: string;
}

const VARIANT_CLASS: Record<SkeletonV2Variant, string> = {
  text: styles.text,
  rounded: styles.rounded,
};

export const SkeletonV2 = ({
  variant = "text",
  surface = "page",
  width,
  height,
  ...rest
}: Props) => {
  const className = [
    styles.skeleton,
    VARIANT_CLASS[variant],
    surface === "elev2" && styles.onElev2,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span
      className={className}
      style={{ width, height }}
      aria-hidden="true"
      {...rest}
    />
  );
};
